import React, { useState } from "react"
import { Link } from "gatsby"
import { useSidebarMenuQuery } from '../../hooks/use-sidebar-menu-query'
import { useCommonItemsQuery } from '../../hooks/use-common-items-query'
import styled from '@emotion/styled/macro'
import { Theme2 } from "../Layout"
import { RightRedArrow, LeftRedArrow } from "../SVGs"

const SidebarMenuContainer = styled.div`
margin: 27px 0 3em 0;
padding-top: 50px;
box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
text-align: center;

ul{
  margin-left: 0;
}
a{
  text-decoration: none;
}
a:hover{
  text-decoration: none;
}
hr{
  width: 48px;
  height: 5px;
  background-color: ${Theme2.colors.neutral};
  margin-bottom: 30px;
  border: none;
}
li{
  border-top: 2px solid ${Theme2.colors.neutral};
  border-bottom: 2px solid ${Theme2.colors.neutral};
  display: grid;
  grid-template-columns: auto 20%;
  margin: 0;

  a{
    color: ${Theme2.colors.dark1};
    text-transform: uppercase;
  padding: 32px 31px 37px 51px;
  font-weight: 700;
  font-size: 15px;
  display: inline-block;
  }

  ul{
    grid-column: 1 / span 2;
  }
}
li:hover{
  background-color: ${Theme2.colors.light2};
  color: ${Theme2.light};
  ul{
    background-color: ${Theme2.colors.light};
    color: ${Theme2.colors.dark2};
  }
}
.firstItem{
  border-top: none;
}
button{
  background: none;
	color: inherit;
	border: none;
	padding: 0;
	font: inherit;
	cursor: pointer;
	outline: inherit;
}
`
const SidebarMenuTitle =styled(Link)` 
color: ${Theme2.colors.dark1};
font-size: 38px;
font-family: ${Theme2.fonts.alternateHeadings};
`

const SidebarMenu = () =>{
  const[isHidden , setIsHidden] = useState({})
  const[isHidden2 , setIsHidden2] = useState({})
 
const toggleHidden = (key) => {
  setIsHidden(prev => Boolean(!prev[key]) ? {...prev, [key]: true} : {...prev, [key]: false});
}

const toggleHidden2 = (key) => {
  setIsHidden2(prev => Boolean(!prev[key]) ? {...prev, [key]: true} : {...prev, [key]: false});
}
  const data = useSidebarMenuQuery();
  const { commonItemsSidebarMenuTitle,
    commonItemsSidebarMenuTitleLink} = useCommonItemsQuery();
    return(
      <SidebarMenuContainer>
        <SidebarMenuTitle to={commonItemsSidebarMenuTitleLink.url}>{commonItemsSidebarMenuTitle}</SidebarMenuTitle>
        <hr />
        <ul>
        
        {data.nodes.map(menuItem => {
          return(
                 <li key={menuItem.label} className={menuItem.cssClasses}>
                   <Link to={menuItem.path}>{menuItem.label}</Link><button key={menuItem.id} onClick={() =>toggleHidden(menuItem.id)}>{isHidden[menuItem.id] ? <LeftRedArrow /> : <RightRedArrow />}</button>
                   {isHidden[menuItem.id] ?
                   menuItem.childItems.nodes.length &&
                   <ul>
                   {menuItem.childItems.nodes.map(secondLevel => {
                     return(
                     <li key={secondLevel.label}>
                       <Link to={secondLevel.path}>{secondLevel.label}</Link>
                       
                       {secondLevel.childItems.nodes.length !==0 &&
                       <>
                       <button key={secondLevel.id} onClick={() =>toggleHidden2(secondLevel.id)}>{isHidden2[secondLevel.id] ? <LeftRedArrow /> : <RightRedArrow />}</button>
                       {isHidden2[secondLevel.id] ?
                       
                         <ul>
                           {secondLevel.childItems.nodes.map(thirdLevel =>{
                             return(
                             <li key={thirdLevel.label}>
                               <Link to={thirdLevel.path}>{thirdLevel.label}</Link>
                             </li>
                           )
                           })}
                       
                         </ul> : null
                   }
                         </>
                   }
                     </li>
                   )
                   })}
                   </ul> : null
        
        }
                   </li>
          )
          
                })}
        </ul>
        
        </SidebarMenuContainer>
    )
}

export default SidebarMenu